export const RECHNUNGSADRESSE = "4446";
export const FIRMA = "4450";
export const GESCHAEFTSADRESSE = "4449";
export const ARBEITGEBER = "4456";
export const KONTAKT = "4471";
export const GEMERKT = "20442";
export const KORRESPONDENZ_ADDRESSE = "22242";
export const KORRESPONDENZ_NEWSLETTER = "55208";
